// Convention Outreach Data — NJ / NYC / Philadelphia region only.
// Contact emails marked ✓ are confirmed from official sources.
// Others are the best known contact point for that organization.

export const CONVENTION_SEED = [

  // ── MARCH 2026 ─────────────────────────────────────────────────────────────
  {
    id: 'monster-mania-66',
    name: 'Monster-Mania Con 66',
    date: '2026-03-06',
    location: 'Cherry Hill, NJ',
    venue: 'DoubleTree by Hilton, 2349 Marlton Pike W',
    website: 'https://monstermania.net',
    contactEmail: 'dave@monstermania.net', // ✓ confirmed
    guests: [
      'Linda Hamilton', 'Edward Furlong', 'Cara Buono',
      'Skeet Ulrich', 'Elisabeth Shue', 'Thomas Jane',
      'Katie Featherston', 'Micah Sloat', 'Jake "The Snake" Roberts',
    ],
    status: 'pending',
    notes: 'Horror/sci-fi focused. Strong crossover with cinematic dark brand. Dave is the direct contact.',
  },

  // ── APRIL 2026 ─────────────────────────────────────────────────────────────
  {
    id: 'horror-sideshow-market-april-2026',
    name: 'Horror Sideshow Market',
    date: '2026-04-18',
    location: 'Asbury Park, NJ',
    venue: 'Berkeley Oceanfront Hotel',
    website: 'https://horrorsideshowmarket.com',
    contactEmail: 'horrorsideshowmarket@gmail.com', // ✓ confirmed
    guests: ['Vendor/artist market — celebrity guests TBD'],
    status: 'pending',
    notes: 'Run by same org as NJ Horror Con. Good relationship to build. Smaller, intimate event — great for reel b-roll.',
  },
  {
    id: 'super-jersey-expo-2026',
    name: 'Super Jersey Comic Expo',
    date: '2026-04-18',
    location: 'Hillsborough, NJ',
    venue: 'Iron Peak Sports & Events',
    website: 'https://www.superjerseyexpo.com',
    contactEmail: 'info@superjerseyexpo.com',
    guests: [
      'John Romita Jr.', 'Fabian Nicieza', 'Larry Hama',
      'Greg Weisman', 'Jim Starlin', 'Media guests TBD',
    ],
    status: 'pending',
    notes: '80,000 sq ft venue. NJ-based expo — perfect local partnership target. 2026 media guests not yet announced.',
  },
  {
    id: 'chiller-theatre-spring-2026',
    name: 'Chiller Theatre Expo',
    date: '2026-04-24',
    location: 'Parsippany, NJ',
    venue: 'Hilton Parsippany',
    website: 'http://www.chillertheatre.com',
    contactEmail: 'chillertheatre@gmail.com',
    guests: [
      'Michael Biehn', 'Michael Cudlitz', 'Dee Wallace',
      'Barbara Crampton', 'Seth Gilliam', 'Tom Wilson',
      'Dominique Swain', 'Mark Boone Junior', 'William Hope',
      'Jamie Farr', 'Jenette Goldstein', 'Mark Rolston',
    ],
    status: 'pending',
    notes: 'One of the biggest horror cons in the NE. Bi-annual (Spring + Fall). Strong A-list horror talent. High priority.',
  },
  {
    id: 'cobra-kai-expo-nj-2026',
    name: 'Salute to Cobra Kai — NJ',
    date: '2026-04-25',
    location: 'Whippany, NJ',
    venue: 'Hanover Marriott Hotel, 1401 Route 10 East',
    website: 'https://www.creationent.com/cal/cobra_nj/',
    contactEmail: 'convention@creationent.com',
    guests: [
      'William Zabka', 'Mary Mouser',
      'Tanner Buchanan', 'Xolo Maridueña',
      'Ralph Macchio (2025 — check 2026 lineup)',
    ],
    status: 'pending',
    notes: 'Creation Entertainment event. Dedicated Cobra Kai/Karate Kid cast con. Intimate venue — great for hero reel.',
  },

  // ── MAY 2026 ───────────────────────────────────────────────────────────────
  {
    id: 'fan-expo-philly-2026',
    name: 'Fan Expo Philadelphia',
    date: '2026-05-29',
    location: 'Philadelphia, PA',
    venue: 'Pennsylvania Convention Center',
    website: 'https://fanexpohq.com/fanexpophiladelphia/',
    contactEmail: 'media@fanexpohq.com',
    guests: [
      'Elijah Wood', 'Sean Astin', 'Dominic Monaghan', 'Billy Boyd',
      'Orlando Bloom', 'David Tennant', 'Jonathan Frakes',
      'Brent Spiner', 'Jim Lee', 'Frank Miller',
    ],
    status: 'pending',
    notes: 'Massive A-list lineup. The 4 Hobbits + Orlando Bloom in one place. High priority — pitch media credentials ASAP.',
  },
  {
    id: 'nj-horror-con-spring-2026',
    name: 'NJ Horror Con & Film Festival',
    date: '2026-05-29',
    location: 'Iselin, NJ',
    venue: 'Delta Hotels Woodbridge, 515 US Rte 1 South',
    website: 'http://www.newjerseyhorrorcon.com',
    contactEmail: 'newjerseyhorrorcon@gmail.com',
    guests: ['Peter Criss (KISS)', 'Xander Goldman', 'Guests TBD'],
    status: 'pending',
    notes: 'Run by same team as Horror Sideshow Market. Good org to build a relationship with — they do multiple events per year.',
  },

  // ── JUNE 2026 ──────────────────────────────────────────────────────────────
  {
    id: 'garden-state-comic-fest-summer-2026',
    name: 'Garden State Comic Fest',
    date: '2026-06-27',
    location: 'West Orange, NJ',
    venue: 'Codey Arena, 560 Northfield Ave',
    website: 'https://www.gardenstatecomicfest.com',
    contactEmail: 'info@gardenstatecomicfest.com',
    guests: [
      'Kevin Eastman (TMNT co-creator)',
      'Amy Jo Johnson (Pink Power Ranger)',
      'Jim Starlin (creator of Thanos)',
      "J. O'Barr (creator of The Crow)",
    ],
    status: 'pending',
    notes: 'Homegrown NJ con. Strong creator guest lineup. Amy Jo Johnson is a great name for the hero reel pitch.',
  },

  // ── AUGUST 2026 ────────────────────────────────────────────────────────────
  {
    id: 'monster-mania-67',
    name: 'Monster-Mania Con 67',
    date: '2026-08-14',
    location: 'Cherry Hill, NJ',
    venue: 'DoubleTree by Hilton, 2349 Marlton Pike W',
    website: 'https://monstermania.net',
    contactEmail: 'dave@monstermania.net', // ✓ confirmed
    guests: ['Guests TBD — typically announced 2–3 months out'],
    status: 'pending',
    notes: 'Second MMC of the year. Reach out to Dave after locking in MMC 66 coverage.',
  },

  // ── SEPTEMBER 2026 ─────────────────────────────────────────────────────────
  {
    id: 'nj-horror-con-fall-2026',
    name: 'NJ Horror Con — Fall',
    date: '2026-09-25',
    location: 'Iselin, NJ',
    venue: 'Delta Hotels Woodbridge, 515 US Rte 1 South',
    website: 'http://www.newjerseyhorrorcon.com',
    contactEmail: 'newjerseyhorrorcon@gmail.com',
    guests: ['Guests TBD'],
    status: 'pending',
    notes: 'Fall edition. If spring goes well, this is an easy re-book.',
  },

  // ── OCTOBER 2026 ───────────────────────────────────────────────────────────
  {
    id: 'nycc-2026',
    name: 'New York Comic Con',
    date: '2026-10-08',
    location: 'New York, NY',
    venue: 'Javits Center, Manhattan',
    website: 'https://www.newyorkcomiccon.com',
    contactEmail: 'press@reedpop.com',
    guests: ['A-list TBD — 2025 had Sigourney Weaver, Laurence Fishburne, James McAvoy, Ming-Na Wen'],
    status: 'pending',
    notes: 'Biggest con in the NE. Pitch to ReedPop press team. Apply for media credentials early — deadline is usually July. Long shot but worth it.',
  },

  // ── NOVEMBER 2026 ──────────────────────────────────────────────────────────
  {
    id: 'garden-state-comic-fest-fall-2026',
    name: 'Garden State Comic Fest — Vineland',
    date: '2026-11-14',
    location: 'Vineland, NJ',
    venue: 'Vineland Convention Center, 631 E. Landis Ave',
    website: 'https://www.gardenstatecomicfest.com',
    contactEmail: 'info@gardenstatecomicfest.com',
    guests: ['Guests TBD'],
    status: 'pending',
    notes: 'South Jersey edition of GSCF. If summer goes well, easy follow-up.',
  },
  {
    id: 'nj-horror-con-rad-mall-2026',
    name: 'NJ Horror Con — RAD MALL',
    date: '2026-11-14',
    location: 'Asbury Park, NJ',
    venue: 'Berkeley Oceanfront Hotel',
    website: 'http://www.newjerseyhorrorcon.com',
    contactEmail: 'newjerseyhorrorcon@gmail.com',
    guests: ['Guests TBD'],
    status: 'pending',
    notes: 'Smaller format event at the oceanfront hotel. Good cinematic location for b-roll.',
  },
  {
    id: 'monster-mania-69',
    name: 'Monster-Mania Con 69',
    date: '2026-11-20',
    location: 'Oaks, PA',
    venue: 'Greater Philadelphia Expo Center',
    website: 'https://monstermania.net',
    contactEmail: 'dave@monstermania.net', // ✓ confirmed
    guests: ['Guests TBD'],
    status: 'pending',
    notes: 'Philly-area edition of MMC. If Cherry Hill goes well, Dave will likely welcome you here too.',
  },
  {
    id: 'big-apple-comic-con-2026',
    name: 'Big Apple Comic Con',
    date: '2026-11-21',
    location: 'New York, NY',
    venue: 'The New Yorker Hotel, 481 8th Ave',
    website: 'https://bigapplecc.com',
    contactEmail: 'info@bigapplecc.com',
    guests: [
      'Lawrence Lieber (co-creator Thor, Iron Man, Ant-Man)',
      'Jim Steranko', 'Dave Dorman',
    ],
    status: 'pending',
    notes: 'Smaller NYC con — more accessible for media access than NYCC. Good entry point into the NYC market.',
  },

  // ── ONGOING / ROLLING ──────────────────────────────────────────────────────
  {
    id: 'yestercades-red-bank',
    name: 'Yestercades — Celebrity Appearances',
    date: '2026-04-17',
    location: 'Red Bank, NJ',
    venue: 'Yestercades Arcade, 80 Broad St',
    website: 'https://yestercades.com',
    contactEmail: 'info@yestercades.com',
    guests: ['Celebrity pop-ups — typically announced with short lead time'],
    status: 'pending',
    notes: 'Retro arcade in Red Bank — hosts surprise celebrity nights. Follow their Facebook/IG for announcements. Great intimate venue for a short-form doc reel.',
  },
  {
    id: 'nj-cannabis-celebrity-appearances',
    name: 'NJ Cannabis — Celebrity Appearances',
    date: '2026-04-20',
    location: 'Jersey City, NJ',
    venue: 'Various NJ Dispensaries',
    website: 'https://headynj.com',
    contactEmail: 'jessica@uproarpr.com', // ✓ ICE-T event PR contact
    guests: ['ICE-T (past)', '4/20 celebrity drops TBD'],
    status: 'pending',
    notes: 'ICE-T did a meet & greet at The Medicine Woman, 660 Tonnelle Ave, Jersey City Oct 2025. PR contact Jessica Penzari handled it. 4/20 events typically announced 2–3 weeks out. Monitor headynj.com.',
  },
];

export const STATUS_CONFIG = {
  pending:  { label: 'Pending',  color: 'text-amber-400',  bg: 'bg-amber-400/10',  border: 'border-amber-400/30'  },
  sent:     { label: 'Sent',     color: 'text-blue-400',   bg: 'bg-blue-400/10',   border: 'border-blue-400/30'   },
  booked:   { label: 'Booked',   color: 'text-emerald-400',bg: 'bg-emerald-400/10',border: 'border-emerald-400/30'},
  declined: { label: 'Declined', color: 'text-red-400',    bg: 'bg-red-400/10',    border: 'border-red-400/30'    },
};

export function generatePitchEmail(event) {
  const topGuests = event.guests
    .filter((g) => !g.toLowerCase().includes('tbd') && !g.toLowerCase().includes('guest'))
    .slice(0, 3);
  const guestLine =
    topGuests.length > 0
      ? `an incredible lineup including ${topGuests.join(', ')}`
      : 'an exciting lineup of guests';

  const subject = `Media Partnership Proposal — ${event.name} | Black Magic Films`;

  const body = `My name is Mike, and I'm the founder of Black Magic Films — a cinematic media production company based in New Jersey.

I came across ${event.name}${event.date ? ` (${new Date(event.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })})` : ''} and noticed you have ${guestLine}. I'd love to propose a media partnership that brings Hollywood-grade production value to your event coverage — at no cost to you.

WHO I AM
I'm the cinematographer and editor behind the visual content for Kevin Smith's The Secret Stash and Smodcastle Cinemas — two of New Jersey's most recognized entertainment brands. My work has been featured across social media and used for event marketing by the venues themselves.

THE GEAR
I shoot exclusively on the Blackmagic Cinema 6K Pro with Sigma Art lenses — the same cinema-grade equipment used on professional film productions. Every deliverable is color-graded in DaVinci Resolve for a polished, theatrical finish.

THE PARTNERSHIP OFFER
In exchange for media credentials and floor access, I'll deliver the following assets to ${event.name} — completely free of charge:

  • A 60-second "Hero Reel" — a high-energy, color-graded cinematic recap built for your website, trailers, and sponsor decks
  • 3–5 vertical social clips — aspect-ratio perfect for TikTok and Instagram Reels
  • 48-hour turnaround on social content — so you can capitalize on the post-event conversation while it's still live

All assets are yours to use across all channels, forever.

WHY THIS MATTERS
Most conventions invest heavily in photography but leave video on the table. A 60-second Hero Reel is the most shareable, most reusable piece of marketing content an event can own — and it makes your next event dramatically easier to sell to sponsors, talent agents, and future attendees.

I'd love to connect and talk through the details. Even a quick email exchange works.

Looking forward to hearing from you,

Mike
Black Magic Films
mike@blackmagicfilms.com
https://blackmagicfilms.com
Instagram: @blackmagicfilms_
YouTube: @blackmagickuper`;

  return { subject, body };
}
